/**
 * @desc undefined
 */
import { BankEntity } from '@eastcoal/api/finance/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type SetDefaultBankParameter = {
  id?: string
}

const method = 'POST'
const url = '/finance/bank/default'

export const setDefaultBankApi = (
  params?: SetDefaultBankParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<BankEntity>({
    method,
    url,
    params,
    ...config
  })
}

setDefaultBankApi.method = method
setDefaultBankApi.url = url
